'use client';

import ProductCard from '@components/Cards/ProductCard';
import RelatedGrid from '@repo/ui/src/components/RelatedGrid';
import useProducts from '@hooks/product/useProducts';
import { ToutContentProps } from '@repo/ui/src/types/toutContent';
import { ImageProps } from '@repo/ui/src/types/image';
import { ProductModelProps } from '@typings/product';

interface Props {
  toutContent?: ToutContentProps;
  backgroundImage?: ImageProps;
  saleText?: string;
  newText?: string;
  _data: Array<ProductModelProps>;
}

const RelatedProductGrid = ({
  toutContent,
  backgroundImage,
  saleText,
  newText,
  _data = [],
}: Props) => {
  const { products } = useProducts(_data);
  return (
    <RelatedGrid toutContent={toutContent} backgroundImage={backgroundImage}>
      {products.slice(0, 6).map((product, index) => (
        <li
          key={index}
          className="[&:nth-child(n+5)]:tw-hidden lg:[&:nth-child(n+5)]:tw-block tw-border tw-border-warm-200 tw-bg-neutral-100"
        >
          <ProductCard product={product} saleText={saleText} newText={newText} />
        </li>
      ))}
    </RelatedGrid>
  );
};

export default RelatedProductGrid;
